export function LandingSearch() {
	return (
		<div className="mx-auto max-w-[1400px] px-6 lg:px-12">
			<div className="mx-auto flex max-w-4xl flex-col items-center">
				<div className="flex w-full flex-col items-center gap-4">
					<div className="group relative w-full max-w-2xl">
						<input
							className="border-ivory/10 bg-dark-accent text-ivory placeholder-ivory/30 focus:border-gold/50 w-full border py-5 pr-36 pl-6 text-base font-light transition-all focus:ring-0 focus:outline-none"
							placeholder="Paste a YouTube URL..."
							type="text"
						/>
						<button
							className="bg-gold text-warm-gray hover:bg-ivory absolute top-2 right-2 bottom-2 px-8 text-[11px] font-bold tracking-widest uppercase transition-colors"
							type="button"
						>
							Extract Findings
						</button>
					</div>
					<div className="text-ivory/40 font-sans text-xs font-light tracking-widest uppercase">
						Try:{" "}
						<span className="border-ivory/30 text-ivory/60 hover:border-gold hover:text-gold ml-1 cursor-pointer border-b transition-colors">
							Naval on Wealth
						</span>
						,{" "}
						<span className="border-ivory/30 text-ivory/60 hover:border-gold hover:text-gold mx-1 cursor-pointer border-b transition-colors">
							Karpathy on LLMs
						</span>
						,{" "}
						<span className="border-ivory/30 text-ivory/60 hover:border-gold hover:text-gold cursor-pointer border-b transition-colors">
							Huberman Lab
						</span>
					</div>
				</div>
			</div>
		</div>
	);
}
